/**
 * Texts (`en`) of the «Articles» section of the supplier card (OBR-186): what we buy from them. Own slice: `en.ts`
 * is not touched. The three languages must have the same keys (i18n.test.ts); no literal text in the views.
 */

export const supplierArticlesEn = {
  'backoffice.supplierArticles': {
    // Section of the supplier dialog.
    sectionTitle: 'Articles',
    sectionHint:
      'What we buy from them: the articles linked to this supplier, with their reference, purchase unit and price. Read-only; the links are edited from the article card or with the article-supplier importer.',
    sectionNewHint:
      'The articles we buy from them will show here once you have saved the supplier.',
    loadError: 'The articles of this supplier could not be loaded.',
    empty: 'There are no articles linked to this supplier yet.',
    emptyFiltered: 'No article matches the search and filters.',

    // Search and filters.
    searchLabel: 'Search by code, name or reference',
    filterStatus: 'Article status',
    statusActive: 'Active only',
    statusAll: 'All (active and deactivated)',
    statusInactive: 'Deactivated only',
    filterDefault: 'Default supplier',
    defaultAll: 'All',
    defaultYes: 'Only those where it is the default',
    defaultNo: 'Only those where it is not the default',
    filterUnit: 'Purchase unit',
    unitAll: 'All',
    unitBulk: 'Bulk (base unit)',

    // Count under the filters.
    summary_one: '{{count}} article',
    summary_other: '{{count}} articles',
    summaryOf_one: '{{shown}} of {{count}} article',
    summaryOf_other: '{{shown}} of {{count}} articles',
    hiddenInactive_one: '{{count}} deactivated article hidden',
    hiddenInactive_other: '{{count}} deactivated articles hidden',

    // List columns.
    colCode: 'Code',
    colArticle: 'Article',
    colRef: 'Supplier reference',
    colUnit: 'Purchase unit',
    colPrice: 'Purchase price',
    colDefault: 'Default',
    colStatus: 'Status',

    // Cells.
    badgeDefault: 'Default',
    badgeActive: 'Active',
    badgeInactive: 'Inactive',
    articleUnavailable: 'Article not available',
    unitUnavailable: 'Unit not available',
    formatEquivalence: '1 {{unit}} = {{quantity}} {{base}}',
    formatBulk: 'Bulk',
    pricePerUnit: '{{price}} €/{{unit}}',
    priceNoUnit: '{{price}} €',
    openArticleHint: 'Open the card of «{{name}}» in a new tab',

    // Excel export.
    exportExcel: 'Export to Excel',
    exportBusy: 'Building the Excel…',
    exportError: 'The Excel could not be built. Please try again.',
    exportHint:
      'The Excel carries the articles as they are shown now, with the search and filters applied.',
    excelSheetName: 'Articles',
    excelFileName: 'articles-{{supplier}}.xlsx',
    excelFileFallback: 'supplier',
    excelColCode: 'Article code',
    excelColName: 'Article',
    excelColRef: 'Supplier reference',
    excelColDescription: 'Supplier description',
    excelColUnit: 'Purchase unit',
    excelColFormat: 'Equivalence',
    excelColPrice: 'Purchase price (per base unit)',
    excelColBaseUnit: 'Base unit',
    excelColDefault: 'Default supplier',
    excelColStatus: 'Article status',
    excelYes: 'Yes',
    excelNo: 'No',
  },
} as const;
